// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5972) return "static/chunks/5972.a00177ffa076703f.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5730 ? "44530001" : chunkId) + "-" + {"4246":"8355a561c0060ead","4542":"6ce9cf50adc489c9","5730":"4c43e402a41c8493","9686":"bd9e6e49577c21d3"}[chunkId] + ".js";
};